/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import {
    string, object, any,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';

const styles = () => ({
    customWrapper: {
        minWidth: 397,
        minHeight: 283,
        maxWidth: 600,
        maxHeight: 400,
        borderRadius: 20,
        backgroundSize: 'cover',
    },
    customContentContainer: {
        marginLeft: 28,
        marginTop: 33,
        width: 340,
        height: 220,
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});
const CustomsCardWrapper = ({
    customsCard, classes, children,
}) => (
    <Grid className={classes.customWrapper} style={{ backgroundImage: `url(${customsCard})` }}>
        <Grid className={classes.customContentContainer}>
            {children}
        </Grid>
    </Grid>
);

CustomsCardWrapper.propTypes = {
    classes: object.isRequired,
    customsCard: string.isRequired,
    children: any,
};

CustomsCardWrapper.defaultProps = {
    children: {},
};
export default withStyles(styles)(CustomsCardWrapper);
